import { StyleSheet } from "../../StyleSheet";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { Card, Col, Row, Space, Typography } from 'antd';
import ListItemAccordion from "../../components/ListItemAccordion";
import { useCallback, useEffect, useState } from "react";
import PaymentAmount from "./components/PaymentAmount";
import Barcode from "react-barcode";
import { getExpirationCard, getPaymentsCenters, getPaymentsGeneral } from "../../methods/Methods";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { AppDispatch } from "../../stores/store";
import { clearDueDate, fillDueDateSlice, getDueDate } from "../../stores/slices/dueDateSlice";
import { CentersPayment, GenericResponse, ResponsePaymentGeneral, ResponsePaymentsCenters, Tarjeta } from "../../types/common";
import Loading from "../../components/Loading";
import InfoCardComponent from "../../components/InfoCardComponent";
import { getPaymentDataContracts, setPaymentDataToContract } from "../../stores/slices/paymentDataSlice";
const { Text } = Typography;

const PaymentCenter = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [paymentData, setPaymentData] = useState<ResponsePaymentGeneral>();
    const dueDate = useSelector(getDueDate);
    const [additionalCardInfo, setAdditionalCardInfo] = useState<JSX.Element | null>(null);
    const [arrayListCenterPayments, setArrayListCenterPayments] = useState<any>([]);
    const [status, setStatus] = useState("");
    const [message, setMessage] = useState("");
    const { selectedContract } = useSelector(getGeneralData);
    const [loading, setLoading] = useState<boolean>(false);
    const [idCliente, setIdCliente] = useState("");
    const [nameComplete, setNameComplete] = useState("");
    const [packageName, setPackageName] = useState<string>("");
    const paymentDataRedux = useSelector(getPaymentDataContracts);
    const [openAccordionIndex, setOpenAccordionIndex] = useState<number | null>(null);
    const [barcode, setBarcode] = useState<string>("");

    const getPaymentCenters = useCallback(async () => {
        setLoading(true);
        const response = await getPaymentsCenters(idCliente);
        if (response.data && response.data.data[0]) {
            let arrayCenterPayments: ResponsePaymentsCenters[] = [];

            response.data.data.forEach((key) => {
                const categoryTitle = _.capitalize(key.category_name);
                const centers = key.centers;

                arrayCenterPayments.push({
                    category_name: categoryTitle,
                    centers: centers,
                });
            });

            arrayCenterPayments.sort((a, b) => {
                const order = ["Bancos", "Supermercados", "Farmacias", "Tienda de conveniencia", "Otros centros"];
                return order.indexOf(a.category_name) - order.indexOf(b.category_name);
            });

            setArrayListCenterPayments(arrayCenterPayments);
            setLoading(false);
        } else {
            setStatus("hasnotinfo");
            setMessage("No hay información para mostrar.");
            setLoading(false);
        }
    }, [idCliente]);

    const consultarDueDate = useCallback(() => {
        if (idCliente) {
            setLoading(true);
            dispatch(fillDueDateSlice({ clientId: idCliente }));
        }
    }, [dispatch, idCliente]);

    const getPaymentData = useCallback(async () => {
        setLoading(true);
        await getPaymentsGeneral(idCliente)
            .then(async (response: GenericResponse<ResponsePaymentGeneral>) => {
                if (!_.isEmpty(response.data)) {
                    let recurrentCard: Tarjeta | null = null;
                    await getExpirationCard(idCliente)
                        .then((response) => {
                            if (response.data && response.data.data[0]) {
                                //Si el campo tarjeta no está null es porque tiene tarjeta domiciliada
                                //Y si es diferente del cod 902
                                if (!_.isNull(response.data.data[0].tarjeta) && response.data.data[0].codigo !== "902") {
                                    recurrentCard = response.data.data[0].tarjeta;
                                }
                            }
                        })
                        .catch(() => {
                        });
                    setPaymentData(response.data[0]);
                    dispatch(setPaymentDataToContract({
                        clientId: idCliente,
                        paymentData: response.data[0],
                        recurrentCard: recurrentCard
                    }));
                }
                else {
                    setPaymentData(undefined);
                }
                setLoading(false);
            }).catch(() => {
                setPaymentData(undefined);
                setLoading(false);
            });
    }, [dispatch, idCliente]);

    const handleAccordionClick = (index: number) => {
        if (openAccordionIndex === index) {
            setOpenAccordionIndex(null);
        } else {
            setOpenAccordionIndex(index);
        }
    };

    useEffect(() => {
        // Limpiar datos antes de cargar nuevos datos
        setPaymentData(undefined);
        setAdditionalCardInfo(null);
        setArrayListCenterPayments([]);
        setStatus("");
        setMessage("");
        setLoading(true);
    }, [idCliente]);

    useEffect(() => {
        switch (dueDate.status) {
            case 1:
                setLoading(false);
                break;
            case 2:
                setLoading(false);
                break;
            default:
                setLoading(true);
                break;
        }
    }, [dueDate.status]);

    useEffect(() => {
        if (selectedContract !== null) {
            setIdCliente(selectedContract.sucursal + selectedContract.suscriptor);
            setNameComplete(selectedContract?.nombre + " " + selectedContract?.apellidoPaterno + " " + selectedContract?.apellidoMaterno);
            setPackageName(selectedContract.paquete)
        }
    }, [selectedContract]);

    useEffect(() => {
        if (!_.isEmpty(idCliente)) {
            if (dueDate.clientId !== idCliente) {
                dispatch(clearDueDate());
            }
        }
    }, [idCliente, dueDate, dispatch]);

    useEffect(() => {
        if (!_.isEmpty(idCliente)) {
            getPaymentCenters();
        }
    }, [idCliente, getPaymentCenters]);

    useEffect(() => {
        if (dueDate.data) {
            setBarcode(dueDate.data.generalData.codigoBarras);
            setLoading(false);
        } else {
            consultarDueDate();
        }
    }, [dueDate.data, consultarDueDate]);
    
    useEffect(() => {
        if (idCliente) {
            const index = paymentDataRedux.contracts.findIndex(obj => obj.clientId === idCliente);
            if (index >= 0) {
                setPaymentData(paymentDataRedux.contracts[index].paymentData);
            }
            else {
                getPaymentData();
            }
        }
    }, [idCliente, getPaymentData, paymentDataRedux.contracts]);


    const renderContent = (section: ResponsePaymentsCenters, index: number) => {
        if (idCliente) {
            const { category_name, centers } = section;

            return (
                <ListItemAccordion
                    key={category_name}
                    label={category_name}
                    children={centers}
                    openCard={(element: CentersPayment) => addAdditionalCard(element)}
                    onClick={() => handleAccordionClick(index)}
                    isOpen={index === openAccordionIndex}
                />
            );
        }
    };

    const addAdditionalCard = (element: CentersPayment) => {
        if (idCliente && element) {
            const lineaCaptura = _.get(dueDate.data?.generalData, element.capture_line, '');
            let newCaptureLine = "";

            switch (element.capture_line) {
                case "lineaBancomer":
                    newCaptureLine = "801720";
                    break;
                case "lineaSantander":
                    newCaptureLine = "1332";
                    break;
                case "lineaScotiabank":
                    newCaptureLine = "3356";
                    break;
                default:
                    break;
            }

            const updatedCardInfo = (
                <Card style={styles.cardStyle}>
                    {loading ? (
                        <Loading />
                    ) : (
                        <>
                            <Row>
                                <Col span={24} style={{ textAlign: 'center' }}>
                                    <Text style={styles.textSuscriptor}>Suscriptor</Text>
                                    <br />
                                    <Text style={styles.textIdSuscriptor}>{idCliente}</Text>
                                    <br />
                                    <br />
                                    <Text style={styles.textName}>{nameComplete}</Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ textAlign: 'center', marginTop: 15 }}>
                                    <div style={styles.divDate}>
                                        <Text style={styles.textDate}>
                                            Pagar antes del
                                            <Text style={styles.textDate}>
                                                {selectedContract?.diaDeCorte}
                                            </Text>
                                            del mes en curso
                                        </Text>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ justifyContent: 'center', marginTop: 15, display: 'flex' }}>
                                    {element && _.isEqual(element.capture_line, "codigoBarras") ? (
                                        barcode && !_.isEmpty(barcode) ? (
                                            <Barcode
                                                fontSize={15}
                                                value={barcode}
                                                background={'transparent'}
                                                format="CODE128"
                                                width={1.5}
                                                height={60} />
                                        ) : null
                                    ) : (
                                        <>
                                            <Col span={24} style={{ textAlign: 'center' }}>
                                                <Text style={styles.lineCapture}>Linea De Captura</Text>
                                                <br />
                                                <Text style={{ ...styles.lineCapture, fontSize: 16, fontWeight: 600 }}>{lineaCaptura}</Text>
                                                {newCaptureLine ? (
                                                    <Col span={24} style={{ textAlign: 'center', marginTop: 20 }}>
                                                        <Text style={styles.lineCapture}>Convenio</Text>
                                                        <br />
                                                        <Text style={{ ...styles.lineCapture, fontSize: 16, fontWeight: 600 }}>{newCaptureLine}</Text>
                                                    </Col>
                                                ) : null}
                                            </Col>
                                        </>
                                    )}
                                </Col>
                            </Row>
                        </>
                    )}
                </Card >
            );
            setAdditionalCardInfo(updatedCardInfo);
        }
    };

    return (
        <>
            {
                loading || _.isNull(paymentData) ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Pagar en Centros de Cobro Asociados"} needReturn={true} navigateTo={'/payments'}>
                        {
                            _.isEmpty(status) ? (
                                <>
                                    <Row>
                                        <Col span={24}>
                                            <PaymentAmount paymentData={paymentData} packageName={packageName} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={12} style={styles.divRoot}>
                                            <Space direction="vertical">
                                                {arrayListCenterPayments.map((section: any, index: number) => (
                                                    renderContent(section, index)
                                                ))}
                                            </Space>
                                        </Col>
                                        <Col span={12} style={{ ...styles.divRoot }}>
                                            {additionalCardInfo}
                                        </Col>
                                    </Row>
                                </>
                            ) : (
                                <InfoCardComponent
                                    title="¡Estimado Usuario!"
                                    description={message}
                                />
                            )
                        }
                    </SubDefaultLayout>
            }
        </>
    );
};

const styles = StyleSheet.create({
    cardStyle: {
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 12,
    },
    divRoot: {
        display: "flex",
        flexDirection: "column",
        marginTop: 20
    },
    textSuscriptor: {
        fontSize: 19,
        fontWeight: 600
    },
    textIdSuscriptor: {
        fontSize: 16,
        marginBottom: 20
    },
    textName: {
        fontSize: 17,
        color: '#7c7f84',
        marginTop: 20
    },
    textDate: {
        fontSize: 12,
        fontWeight: 600,
        color: 'white',
        textTransform: 'uppercase',
        padding: 5
    },
    divDate: {
        backgroundColor: '#0055c2',
        width: '100%',
        height: 35,
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    lineCapture: {
        fontSize: 14,
        color: '#1858ac',
        textTransform: 'capitalize',
    }
});

export default PaymentCenter;
